<template>
  <div class="table">
    <el-table
      :data="allWorkRate"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      v-loading="tableLoading || loading"
      empty-text=""
    >
      <div slot="empty">
        <NoDataToView
          v-if="!tableLoading"
          link="/admin/attendance/overtime/settings/work-rate/create"
          :showButton="showCreateWorkRate"
          btnText="Work Rate"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateWorkRate"
                @click="$emit('clear')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" width="80"></el-table-column>
      <el-table-column
        sortable
        prop="group_name"
        label="GROUP NAME"
      ></el-table-column>
      <el-table-column
        sortable
        prop="monthly_salary"
        label="MONTHLY SALARY(NGN)"
      ></el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template slot-scope="scope">
          <div class="actions">
            <button @click="viewWorkRate(scope.row.id)">
              <img src="/img/view.svg" alt="view" />
            </button>
            <button @click="handleEditWorkRate(scope.row.id)">
              <img src="/img/pencil-edit.svg" alt="edit" />
            </button>
            <button @click="deleteAWorkRate(scope.row.id)">
              <img src="/img/delete.svg" alt="delete" />
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <button
            class="line pointer black"
            @click="assignEmployee(scope.row.id)"
          >
            Assign Employee
          </button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container" v-if="!tableLoading">
      <el-pagination
        mini
        @size-change="handleSizeChangeWorkRate"
        @current-change="handleCurrentChangeWorkRate"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageWorkRate"
        layout="total, sizes, prev, pager, next, jumper"
        :total="workRateTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import NoDataToView from "@/components/general/NoDataToView.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/attendance/overtime"
);
export default {
  components: {
    NoDataToView,
  },
  props: ["allWorkRate", "searchQuery", "workRateTotal"],
  data() {
    return {
      loading: false,
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  computed: {
    ...mapState(["tableLoading", "pageWorkRate", "perPageWorkRate"]),
    currentPage: {
      get() {
        return this.pageWorkRate;
      },
      set(value) {
        return this.$store.commit(
          "admin/attendance/overtime/OVERTIME_MUTATIONS",
          {
            key: "pageWorkRate",
            value,
          }
        );
      },
    },
    showCreateWorkRate() {
      return !this.allWorkRate.length && !this.searchQuery;
    },
    noDataMessage() {
      let message = `You are yet to create work rate`;
      if (this.showCreateWorkRate) {
        return message;
      }
      if (this.searchQuery !== "") {
        return `${message} ${this.searchQuery ? "for " : ""} ${
          this.searchQuery
        } `;
      }
      return `${message}`;
    },
  },
  methods: {
    ...mapActions([
      "deleteWorkRate",
      "getWorkRate",
      "handleSizeChangeWorkRate",
      "handleCurrentChangeWorkRate",
    ]),
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    handleEditWorkRate(id) {
      this.$router.push(
        `/admin/attendance/overtime/settings/work-rate/edit/${id}`
      );
    },
    deleteAWorkRate(id) {
      this.$promptModal(
        "Delete Work Rate",
        "Are you sure you want to delete the selected work rate?",
        "Yes, Delete",
        () => this.handleDeleteWorkRate(id)
      );
    },
    handleDeleteWorkRate(id) {
      this.loading = true;
      this.$store.commit("admin/attendance/overtime/OVERTIME_MUTATIONS", {
        key: "pageWorkRate",
        value: 1,
      });
      this.deleteWorkRate(id)
        .then(() => {
          this.loading = false;
          this.getWorkRate();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    viewWorkRate(id) {
      this.$router.push(
        `/admin/attendance/overtime/settings/work-rate/view/${id}`
      );
    },
    assignEmployee(id) {
      this.$router.push({ name: "assign-employee-workrate", params: { id } });
    },
  },
};
</script>
